import * as constants from '../constants/ActionTypes';
import { modalChannels, MODAL_TYPE } from '../constants/UtilVariables';
import { CALLUS_FROM_COMPLAINTS_PAGE, RESET_CALLUS_FROM_COMPLAINTS_PAGE, FROM_EMAIL_PAGE } from '../constants/ActionTypes';

const initialState = {
  isModalOpen: false,
  channel: '',
  fromChannel: '',
  topic: null,
  type: MODAL_TYPE.login,
  message: '',
  endPoint: undefined, // using this endPoint field to land on particular page/view after login.
  isLoggedOutChatEnabled: false,
  fromComplaintsPage: false,
  isPuiTopicEnabled: false,
  fromEmailPage: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case constants.LOAD_MODAL_CONTAINER:
      return {
        ...state,
        isModalOpen: true,
        channel: action.payload && action.payload.channel,
        topic: null,
        endPoint: action.payload && action.payload.endPoint,
        fromComplaintsPage: action.payload && action.payload.fromComplaintsPage,
        fromEmailPage: action.payload && action.payload.fromEmailPage,
      };
    case constants.LOAD_MESSAGE_MODAL:
      return {
        ...initialState,
        isModalOpen: true,
        type: MODAL_TYPE.message,
        message: action.payload && action.payload.message,
        channel: action.payload && action.payload.channel,
        topic: action.payload && action.payload.topic,
      };
    case constants.CLOSE_MODAL_CONTAINER:
      return initialState;

    case constants.LOGIN_CALLUS:
      return {
        ...state, isModalOpen: false, fromChannel: modalChannels.call, topic: action.payload, isLoggedOutChatEnabled: false,
      };
    case constants.LOGIN_CHAT_BOT:
      return {
        ...state, isModalOpen: false, fromChannel: modalChannels.chatBot, topic: action.payload, isLoggedOutChatEnabled: false,
      };
    case constants.LOGIN_CHAT:
      return {
        ...state, isModalOpen: false, fromChannel: modalChannels.chat, topic: action.payload, isLoggedOutChatEnabled: false,
      };
    case constants.LOGIN_MESSAGE_US:
      return {
        ...state, isModalOpen: false, fromChannel: modalChannels.messageUs, topic: action.payload, isLoggedOutChatEnabled: false,
      };
    case constants.LOGIN_EMAIL:
      return {
        ...state, isModalOpen: false, fromChannel: modalChannels.finalEmail, topic: action.payload, isLoggedOutChatEnabled: false,
      };
    case constants.LOGIN_EMAIL_NO_INTENT:
      return {
        ...state, isModalOpen: false, fromChannel: modalChannels.defaultEmail, topic: null, isLoggedOutChatEnabled: false,
      };
    case constants.REQUEST_CALLUS:
    case constants.REQUEST_BY_EMAIL:
      return {
        ...state, isModalOpen: false, fromChannel: '', topic: null, isLoggedOutChatEnabled: false,
      };

    case constants.SET_IS_LOGGED_OUT_CHAT_ENABLED:
      return { ...state, isLoggedOutChatEnabled: action.payload };

    case constants.SET_IS_PUI_TOPIC_SUPPORTED_ENABLED:
      return { ...state, isPuiTopicEnabled: action.payload };

    case constants.SELECT_TOPIC_L1:
    case constants.SELECT_TOPIC_L2:
    case constants.SELECT_TOPIC_L3:
    case constants.SELECT_TOPIC_RESET:
    case constants.LOAD_CHAT_INELIGIBLE_MODAL_CONTAINER:
    case constants.CLOSE_CHAT_INELIGIBLE_MODAL_CONTAINER:
      return initialState;
    case CALLUS_FROM_COMPLAINTS_PAGE:
      return { ...state, fromComplaintsPage: true };
    case RESET_CALLUS_FROM_COMPLAINTS_PAGE:
      return { ...state, fromComplaintsPage: false };
    case FROM_EMAIL_PAGE:
      return { ...state, fromEmailPage: true };
    default:
      return state;
  }
}
